export default __webpack_public_path__ + "static/Bm_ELIB_EzyMedical_Exclusion-b0299bde7640a3a9e2362ec5ef94989e.pdf";